import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import "./App.css";
import "./assets/css/styles.css";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Inspection from "./components/Inspection";
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hours: "00",
      minutes: "00",
      seconds: "00",
      dateAndTime: new Date().toLocaleString("en-NG"),
      theCounter: null,
      isCounting: false,

      // logsHidden: true, 
    };
  }

  // componentDidUpdate() {
  //   localStorage.setItem('AppjsState', JSON.stringify(this.state))
  // }

  // componentDidMount() {
  //   this.AppjsUpdatedState = JSON.parse(localStorage.getItem('AppjsState'))
  //   if (localStorage.getItem('AppjsState')) {
  //     this.setState({
  //       hours: this.AppjsUpdatedState.hours,
  //       minutes: this.AppjsUpdatedState.minutes,
  //       seconds: this.AppjsUpdatedState.seconds,
  //       dateAndTime: this.AppjsUpdatedState.dateAndTime,
  //       theCounter: this.AppjsUpdatedState.theCounter,
  //       isCounting: this.AppjsUpdatedState.isCounting,
  //      })
  //   } else {
  //     this.setState({
  //       hours: "00",
  //       minutes: "00",
  //       seconds: "00",
  //       dateAndTime: new Date().toLocaleString("en-NG"),
  //       theCounter: null,
  //       isCounting: false,
  
  //     })
  //    }
  // }

  

  render() {

    // const showLogs = () => {
    //   this.setState({ logsHidden: false });
    // };
    // const hideLogs = () => {
    //   this.setState({ logsHidden: true });
    // };


    return (
      <div>
        <Navbar {...this.state}
        // showLogs={showLogs}
        // hideLogs={hideLogs}
        />
        <Switch>
          <Route exact path="/" component={Header}></Route>
          <Route
            exact
            path="/inspection"
            render={() => <Inspection {...this.state}
            // showLogs={showLogs}
            // hideLogs={hideLogs}
            />}
          ></Route>
        </Switch>
      </div>
    );
  }
}

export default App;
